import type { EditorReadyOptions } from '@wix/platform-editor-sdk';

export const isStandaloneInstallation = (options: EditorReadyOptions) => !options.origin.info?.appDefinitionId;
export const getIsEditor3 = () => (globalThis as any).commonConfig?.host === 'EDITOR3';
